import { OS_VERSIONS } from '../../assets/js/constant';

// os15动画
import loadingError from '../../assets/lottie/loading-light.json?url';
import loadingErrorDark from '../../assets/lottie/loading-dark.json?url';
import noConnection from '../../assets/lottie/no-connection-light.json?url';
import noConnectionDark from '../../assets/lottie/no-connection-dark.json?url';
import noContent from '../../assets/lottie/no-content-light.json?url';
import noContentDark from '../../assets/lottie/no-content-dark.json?url';

// os16动画
import os16LoadingError from '../../assets/lottie/os16/loading-light.json?url';
import os16LoadingErrorDark from '../../assets/lottie/os16/loading-dark.json?url';
import os16NoConnection from '../../assets/lottie/os16/no-connection-light.json?url';
import os16NoConnectionDark from '../../assets/lottie/os16/no-connection-dark.json?url';
import os16NoContent from '../../assets/lottie/os16/no-content-light.json?url';
import os16NoContentDark from '../../assets/lottie/os16/no-content-dark.json?url';

export interface OsVersionLottieInterface {
  getVersionLottieResource: (version: string, isDark: boolean, status: string) => string;
}

export function useOsVersionLottie(): OsVersionLottieInterface {
  // 版本与资源的映射配置
  const VERSION_RESOURCES = {
    [OS_VERSIONS.OS_15]: {
      error: {
        light: loadingError,
        dark: loadingErrorDark,
      },
      noConnection: {
        light: noConnection,
        dark: noConnectionDark,
      },
      noComment: {
        light: noContent,
        dark: noContentDark,
      },
    },
    [OS_VERSIONS.OS_16]: {
      error: {
        light: os16LoadingError,
        dark: os16LoadingErrorDark,
      },
      noConnection: {
        light: os16NoConnection,
        dark: os16NoConnectionDark,
      },
      noComment: {
        light: os16NoContent,
        dark: os16NoContentDark,
      },
    },
    // 默认版本资源
    default: {
      error: {
        light: loadingError,
        dark: loadingErrorDark,
      },
      noConnection: {
        light: noConnection,
        dark: noConnectionDark,
      },
      noComment: {
        light: noContent,
        dark: noContentDark,
      },
    }
  };

  const getVersionLottieResource = function (
    version: string,
    isDark: boolean,
    status: string,
  ): string {
    console.log('getVersionLottieResource version', version);
    console.log('getVersionLottieResource isDark', isDark);
    console.log('getVersionLottieResource status', status);
    const resources = VERSION_RESOURCES[version] || VERSION_RESOURCES.default;
    return resources[status][isDark ? 'dark' : 'light'];
  };

  return {
    getVersionLottieResource,
  };
}
